import { configureStore } from '@reduxjs/toolkit';

import authReducer from './AuthReducer';
import CoproReducer from './CoproReducer';
import dashboardReducer from './dashboardSlice';
import DpeOwnerReducer from './DpeOwnerReducer';
import DpeOwnerTreatedReducer from './DpeOwnerTreatedReducer';
import DpeReducer from './DpeReducer';
import moduleReducer from './ModuleReducer';
import salesDataReducer from './SalesDataReducer';

const store = configureStore({
  reducer: {
    auth: authReducer,
    dashboard: dashboardReducer,
    module: moduleReducer,
    copro: CoproReducer,
    dpe: DpeReducer,
    dpeOwner: DpeOwnerReducer,
    dpeOwnerTreated: DpeOwnerTreatedReducer,
    salesData: salesDataReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
